import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { Tooltip, Input, Label, Button, Badge } from "reactstrap"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/kgbService"

import DataTableBloc from '../Blocs/DataTableBloc'
import IndexBloc from "../Blocs/IndexBloc"
import apiResponse from '../../../../../services/apiResponse'
import { withRouter } from "react-router"
import SKModal from "./SKModal";

import moment from 'moment'

class TableDoneComponent extends Component {
    dataTableBloc = new DataTableBloc();
    indexBloc = new IndexBloc();

    source
    historyTable = 'KGBEmpTableDone'
    defaultOrder = 'kgb_temp_id'
    defaultSize = 10
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    modal_confirm_status = 0
    modal_confirm_message = ""
    modal_confirm_sucess_message = "data berhasil diproses"
    modal_confirm_error_message = "data gagal diproses"

    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            draftSkUuid: null,
            uploadSkUuid: null,
            detailUuid: null,
            updateUuid: null,
            inactiveUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
            },
            dataSelected: [],
            checked: false
        }
    }

    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    toggle = () => {
        this.setState({ modal: !this.state.modal })
    }

    dateParse = (input) =>{
        let res = "-";
        if (input != "" && input != null){
            res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    rupiah = (num) => {
        let res = "-";
        if (num != null && num != ''){
            res = parseFloat(num).toLocaleString('id-ID', {maximumFractionDigits:2})
        }
        return res;
    }

    handleChecked = (e, uuid) => {
      var checked = e.target.checked;
      if (checked){
        this.setState({
          dataSelected : [
            ...this.state.dataSelected,
            uuid
          ]
        })
      } else {
        var filteredAry = this.state.dataSelected.filter(e => e !== uuid)
        this.setState({
          dataSelected : filteredAry
        })
      }
      console.log(uuid);
      console.log(checked)
    }

    handleButtonProcess = () => {
      console.log(this.state.dataSelected)
    }

    handleDownloadDraftSK = (uuid) => {
        this.indexBloc.fetchDownloadDraftSK({
            kgb_temp_uuid: uuid
        });
    }

    handleButtonExportLampiran = () => {
        this.indexBloc.fetchExportLampiran({
            period_uuid: this.props.uuid,
        });
    }

    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1,
            period_uuid : this.props.uuid,
            is_process : 2
        }
        await this.dataTableBloc.fetchRowTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.setTokenAPI()

        this.dataTableBloc.rowtableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.indexBloc.downloadDraftSKChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.LOADING:
                    this.setState({
                        loading: true,
                    })
                    break
                case apiResponse.COMPLETED:
                    const link = result.data.response
                    window.open(link.file_url, "_blank")
                    //window.location.href = link.file_url
                    this.setState({
                        loading: false,
                        success: true
                    })
                    setTimeout(() => {
                        this.setState({
                            success: false,
                        })
                    }, 1000);
                    break
                case apiResponse.ERROR:
                    this.setState({
                        urlFileDetail: link,
                        loading: false,
                        failed: true
                    })
                    setTimeout(function() {
                        this.setState({
                            failed: false,
                        })
                    }, 1000)
                    break
                default:
                    break
            }
        })

        this.indexBloc.exportLampiranChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.LOADING:
                    this.setState({
                        loading: true,
                    })
                    break
                case apiResponse.COMPLETED:
                    const link = result.data.response
                    window.open(link.file_url, "_blank")
                    //window.location.href = link.file_url
                    this.setState({
                        loading: false,
                        success: true
                    })
                    setTimeout(() => {
                        this.setState({
                            success: false,
                        })
                    }, 1000);
                    break
                case apiResponse.ERROR:
                    this.setState({
                        urlFileDetail: link,
                        loading: false,
                        failed: true
                    })
                    setTimeout(function() {
                        this.setState({
                            failed: false,
                        })
                    }, 1000)
                    break
                default:
                    break
            }
        })

    }

    componentWillUnmount() {
        this.dataTableBloc.rowtableChannel.unsubscribe()
        this.indexBloc.downloadDraftSKChannel.unsubscribe()
        this.indexBloc.exportLampiranChannel.unsubscribe()
    }

    columns = [
        {
			key: "employee_full_name",
			text: "Pegawai",
			className: "employee_full_name",
			sortable: true,
			cell: record => {
				return (
					<>
						<b>{record.kgb_temp_employee_name}</b>
						<div>{record.kgb_temp_employee_nip}</div>
						<div>{record.kgb_temp_tempat_lahir}, {this.dateParse(record.kgb_temp_tanggal_lahir)}</div>
					</>
				)
			}
		},
		{
			key: "kgb_temp_golongan_ruang",
			text: "Golongan/Ruang",
			className: "kgb_temp_golongan_ruang",
			sortable: true,
		},
		{
			key: "kgb_temp_sk_lama",
			text: "SK Lama",
			className: "kgb_temp_sk_lama",
			sortable: true,
			cell: record => {
				return (
					<>
						<b>{record.kgb_temp_sk_lama}</b>
						<div>{this.dateParse(record.kgb_temp_tanggal_sk_lama)}</div>
					</>
				)
			}
		},
		{
			key: "kgb_temp_masa_kerja_tahun_lama",
			text: "Masa Kerja Lama",
			className: "kgb_temp_masa_kerja_tahun_lama",
			sortable: true,
			cell: record => {
				return (
					<>
						<b>{record.kgb_temp_masa_kerja_tahun_lama} Tahun</b>
						<div>{record.kgb_temp_masa_kerja_bulan_lama} Bulan</div>
					</>
				)
			}
		},
		{
			key: "kgb_temp_gaji_pokok_lama",
			text: "Gaji Lama",
			className: "kgb_temp_gaji_pokok_lama",
			sortable: true,
			cell: record => {
				return this.rupiah(record.kgb_temp_gaji_pokok_lama);
			}
		},
		{
			key: "kgb_temp_tmt_lama",
			text: "TMT Lama",
			className: "kgb_temp_tmt_lama",
			sortable: true,
			cell: record => {
				return this.dateParse(record.kgb_temp_tmt_lama);
			}
		},
		{
			key: "kgb_temp_masa_kerja_tahun",
			text: "Masa Kerja Baru",
			className: "kgb_temp_masa_kerja_tahun",
			sortable: true,
			cell: record => {
				return (
					<>
						<b>{record.kgb_temp_masa_kerja_tahun} Tahun</b>
						<div>{record.kgb_temp_masa_kerja_bulan} Bulan</div>
					</>
				)
			}
		},
		{
			key: "kgb_temp_gaji_pokok_baru",
			text: "Gaji Baru",
			className: "kgb_temp_gaji_pokok_baru",
			sortable: true,
			cell: record => {
				return this.rupiah(record.kgb_temp_gaji_pokok_baru);
			}
		},
		{
			key: "kgb_temp_sk_baru",
			text: "Nomor SK",
			className: "kgb_temp_sk_baru",
			sortable: true,
		},
        {
            key: "action",
            text: "Action",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.kgb_temp_id
                const status = record.kgb_temp_status
                return (
                    <Fragment>
                        {
                          status == 1 ?
                            <span>
                                <button
                                    className="btn btn-primary btn-sm"
                                    id={"detail-" + thisId}
                                    onClick={() => {
                                        this.setState({
                                            detailUuid: record.kgb_temp_uuid
                                        })
                                    }}
                                    style={{
                                        marginRight: '2px',
                                        padding: '2px 5px'
                                    }}>
                                        <i className="uil-file-search-alt"></i>
                                </button>
                                <Tooltip
                                    style={{
                                        marginBottom: 2
                                    }}
                                    placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
                                    toggle={() => {
                                        this.setState({
                                            ["detail" + thisId] : !this.state["detail" + thisId]
                                        })
                                    }}
                                >Detail Data</Tooltip>
                            </span>
                          : ""
                        }
                    </Fragment>
                );
            }
        }
    ]

    render() {
        return (
            <>
                {
                    (accessRole('print')) ?
                        <Button 
                          color="success"
                          onClick={
                            () => {
                              this.handleButtonExportLampiran()
                            }
                          }
                        >Export Data Selesai</Button>
                    : null
                }

                <hr />
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={1000}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI()
                        });
                    }}
                    loading={this.state.loadingTable}
                />
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo={this.modal_confirm_message  }

                    loadingTitle="Memproses data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo = {this.modal_confirm_sucess_message}

                    failedTitle="Gagal!"
                    failedInfo= {this.modal_confirm_error_message }

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />

                <SKModal 
                    modal={this.state.modal} 
                    toggle={() => this.toggle()} 
                    // periodUuid={this.state.period?.cpns_period_uuid} 
                    // uuid={this.state.uuid} 
                    // setUuid={value => this.setUuid(value)} 
                    handleReload={() => this.setTokenAPI()} 
                    uuid={this.state.inputSKUuid} 
                />

                { this.state.uploadSkUuid !== null ?
                    <Redirect to={"/kepegawaian/kgb.html?upload_sk&uuid=" + this.state.uploadSkUuid + "&period_uuid=" + this.props.uuid}/>
                : null }
                { this.state.detailUuid !== null ?
                    <Redirect to={"/kepegawaian/kgb.html?detail&uuid=" + this.state.detailUuid + "&period_uuid=" + this.props.uuid}/>
                : null }
            </>
        )
    }

}

export default TableDoneComponent